// --- Modules
import Node, { payload } from './Node';

class LocalDNS extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Local DNS'
    });
  }
};

export default {
  create: (opts) => {
    let item = new LocalDNS(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
